import React from "react";
import styles from "./product.module.css";
import Navbar from "../../Components/Navbar/Navbar";
import { Col, Container, Row } from "react-bootstrap";
import {
  Heading,
  Paragraph,
} from "../../Components/TextComponents/TextComponents";
import Serving from "../../Components/Serving/Serving";
import Categories from "../../Components/Categories/Categories";

const Product = () => {
  return (
    <React.Fragment>
      <div className={styles.main_section}>
        <Navbar />

        <Container>
          <Row>
            <Col md={6}>
              <div className={styles.hero_section}>
                <Heading color="#fff">
                  {" "}
                  Comprehensive Solutions for a <br /> Global Market
                </Heading>
                <Paragraph color="#fff">
                  Explore our diverse portfolio of products and services
                  designed to meet the evolving needs of industries worldwide.
                  <br />
                  <br />
                  At CrossBorder BTC, we bridge gaps across industries with
                  innovative solutions and quality products. From natural
                  resources to cutting-edge technology, our offerings empower
                  businesses and communities to thrive.
                </Paragraph>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Categories />
      <Serving />


    </React.Fragment>
  );
};

export default Product;
